import React from "react";
import ImgCard from '../../../Assets/Image/png/singleimg.png';
import UniLogo from '../../../Assets/Image/png/unilogo.png';
import Card from "../../../Components/share/cards/Card";
import { ReactComponent as IconCategory } from '../../../Assets/Image/svg/Category.svg';
import BootcampsTickets from "./BootcampsTickets";

function CardInfo(props) {
    return (
        <div >
            <div className="container">
                <div className="mb-[8.3rem]">
                    <h2 className="text-[2.4rem] text-[#212121] mb-[2.7rem] font-bold">بوت کمپ طراحی تبلیغات دیجیتالی برای سازمان های دولتی</h2>
                    <div className="grid grid-cols-3 gap-[2.4rem] shadow-btn rounded-16 pr-[2.5rem] pl-[2.9rem] pt-[3.2rem] pb-[3.6rem]">
                        <div className="bg-[#fff]  col-span-2 flex justify-center rounded-[1.5rem] p-[1.5rem] ">
                            <img src={ImgCard} alt="imgcard" title="imgcard" className="rounded-[1.5rem]" />
                        </div>
                        <div >
                            <Card className="p-[2rem] pt-[2.5rem]">
                                <div className="flex items-center flex-col">
                                    <img src={UniLogo} alt="unilogo" title="unilogo" className="mb-[1.8rem]" />
                                    <h2 className="text-sm text-black mb-[2.2rem]">دانشگاه صنعتی اصفهان</h2>
                                </div>

                                <div className="flex flex-col items-start">
                                    <p className="leading-[1.5rem] text-[1rem] text-right text-gray mb-[4rem]">دارو به ‌عنوان یک کالای استراتژیک شناخته می‌شود و مواد موثره دارویی یا مواد اولیه دارویی نقش مهمی در ویژگی‌های محصول نهایی مانند اثربخشی، کیفیت، دسترسی و قیمت دارو دارند.</p>
                                    <div >
                                        <div className="text-gray text-[1.2rem] mb-[1.2rem]">
                                            <span>شروع بوت کمپ:</span>
                                            <span> ۱۴۰۱/۵/۱۲</span>
                                        </div>
                                        <div className="text-gray text-[1.2rem] mb-[4.2rem]">
                                            <span>پایان بوت کمپ:</span>
                                            <span> ۱۴۰۱/۵/۱۲</span>
                                        </div>

                                        <div className="text-gray text-[1.2rem] mb-[1.2rem] flex flex-col items-start">
                                            <span className="mb-[1.1rem]">5 جلسه</span>
                                            <span className="mb-[1rem]">قیمت :1,500,000 تومان</span>
                                        </div>
                                        <div className="flex items-center">
                                            <IconCategory className="text-gray ml-[.6rem]" />
                                            <em className="text-gray text-[1.2rem]">مارکتینگ</em>
                                        </div>



                                    </div>
                                </div>


                            </Card>
                        </div>
                    </div>
                </div>
                <BootcampsTickets />

            </div>

        </div>
    )
}
export default CardInfo;